'use client';

import * as React from 'react';
import Button from '@mui/material/Button';
import { UploadSimple as UploadSimpleIcon } from '@phosphor-icons/react/dist/ssr/UploadSimple';

import { useDialog } from '../../../hooks/use-dialog';

import { Uploader } from './uploader';
import { File } from '../../core/file-dropzone';
import { getExtension, isPdf } from './file-storage-utils';
import { SetS3Config } from '../../../awsClientConfig';
import { userAccountData, userProfileData } from '../../../Common/profileInfo';
import { v4 as uuidv4 } from "uuid";
import { Storage } from 'aws-amplify';

export interface Props {
  onUploadCompleted: () => void;
}

export function UplaodButton({onUploadCompleted}: Props): React.JSX.Element {
  const uploadDialog = useDialog();

  const uploadFilesHandler = () => {
    uploadDialog.handleClose();
    onUploadCompleted()
  }

  return (
    <React.Fragment>
      <Button onClick={uploadDialog.handleOpen} startIcon={<UploadSimpleIcon />} variant="contained" className='option-primary-button'>
        Upload
      </Button>
      <Uploader onUploaded={uploadFilesHandler} onClose={uploadDialog.handleClose} open={uploadDialog.open} />
    </React.Fragment>
  );
}
